import React from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import Collapse from "@material-ui/core/Collapse";
import LinkMenuItem from "../../components/LinkMenuItem";
import MenuBackButton from "../../components/MenuBackButton";
import MenuHeader from "../../components/MenuHeader";
import {sortAlphaByKey} from "../../../../lib";
import "./style.scss";

export default class MarkerTypesMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategoryId: null
    };
  }

  render() {
    const {facilityId} = this.props.location.query;
    return (
      <React.Fragment>
        <MenuBackButton to={`/marker-settings?facilityId=${facilityId}`} />
        <List>
          <MenuHeader>Marker Types</MenuHeader>
          <Link to={`/marker-types?facilityId=${facilityId}`}>
            <Button className="addMarkerTypeButton" color="secondary" variant="contained">
              New Marker Type
            </Button>
          </Link>
          {this.renderCategories()}
        </List>
      </React.Fragment>
    );
  }

  renderCategories() {
    const categoryMap = this.formatCategories();
    return Object.keys(categoryMap).map(categoryId => {
      let category = categoryMap[categoryId];
      const markerTypes = category.types;
      return (
        <React.Fragment key={categoryId}>
          <Divider />
          <LinkMenuItem
            primary={<p className="menuItemText">{category.name}</p>}
            secondary={`${markerTypes.size} marker types`}
            onClick={this.createClickHandler(markerTypes, categoryId)}
          />
          {this.renderMarkerTypeList(categoryId, markerTypes)}
        </React.Fragment>
      );
    });
  }

  formatCategories() {
    const {markerTypes, categories} = this.props;
    return categories
      .sort((a, b) => sortAlphaByKey(a, b, "name"))
      .reduce((categoryMap, category) => {
        return Object.assign({}, categoryMap, {
          [category._id]: {
            name: category.name,
            types: this.filterSortByCategory(markerTypes, category._id)
          }
        });
      }, {});
  }

  filterSortByCategory(items, categoryID) {
    return items.filter(item => item.category_id === categoryID).sort((a, b) => sortAlphaByKey(a, b, "name"));
  }

  createClickHandler(markerTypes, categoryId) {
    return () => {
      if (markerTypes) {
        this.setState({selectedCategoryId: categoryId});
      }
    };
  }

  renderMarkerTypeList(categoryId, markerTypes) {
    if (!markerTypes) {
      return null;
    }
    return (
      <Collapse timeout="auto" in={categoryId === this.state.selectedCategoryId} unmountOnExit>
        <List component="div" disablePadding>
          {this.renderMarkerType(markerTypes)}
        </List>
      </Collapse>
    );
  }

  renderMarkerType(markerTypes) {
    return markerTypes.map(markerType => (
      <LinkMenuItem
        key={markerType._id}
        to={`/marker-types/${markerType._id}?facilityId=${this.props.location.query.facilityId}`}
        onClick={this.props.onClose}
        primary={
          <div className="markerListItem">
            <img className="markerIcon" align="middle" src={markerType.image.path} alt={markerType.name} />
            {markerType.name}
          </div>
        }
      />
    ));
  }
}

MarkerTypesMenu.propTypes = {
  location: PropTypes.object.isRequired,
  markerTypes: PropTypes.object.isRequired,
  categories: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/Menus/MarkerTypesMenu/index.jsx